/* eslint-disable eqeqeq */
import { useEffect, useState } from "react";
import {
  formatAccountNumber,
  formatBSBNumber,
  formatedAddress,
  formatMobile,
  formatName,
  formatNumber,
} from "../../lib/Misc";
import Spin from "../../components/Spin";
import { getTrustPopupDetail } from "./TrustHelper";
import { ResponsiveDrawerForm } from "../../components/ResponsiveDrawerForm";
import { CardTitle } from "../../components/ui/card";
import DetailPhotoBody from "../../components/DetailPhotoBody";

const TrustDetailsPopup = ({
  trustId,
  // toggleShowModal,
  showView,
  setShowView,
}) => {
  const [trustDetail, setTrustDetail] = useState(null);
  const [trustLoading, setTrustLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      const trustDetailData = await getTrustPopupDetail(trustId, true);
      setTrustDetail(trustDetailData);
      setTrustLoading(false);
    }
    fetchData();
  }, [trustId, setTrustDetail]);

  // eslint-disable-next-line no-unused-vars
  const premiumTypeList = [
    { label: "%", value: "1" },
    { label: "Flat Amount", value: "0" },
  ];

  return (
    <ResponsiveDrawerForm
      description={""}
      title={"Trust Details"}
      handleOpen={() => {}}
      handleClose={() => {}}
      className={"md:w-[65vw]"}
      open={showView}
      buttonClassName={""}
      setOpen={setShowView}
      read={true}
    >
      {trustLoading ? (
        <Spin full expand={true} />
      ) : (
        <div className="md:p-0 p-4">
          <DetailPhotoBody
            textValue={
              trustDetail?.business_name
                ? trustDetail?.business_name?.charAt(0)
                : trustDetail?.first_name?.charAt(0)
            }
            imgURL={trustDetail?.profile_pic}
            profileName={
              trustDetail?.business_name
                ? trustDetail?.business_name
                : formatName(trustDetail?.first_name, trustDetail?.last_name)
            }
          />
          <div className="modal-content">
            <CardTitle className="text-md mb-2">Personal Details</CardTitle>
            <div className="modal-content-details grid grid-cols-1 md:grid-cols-2 gap-3">
              <p>
                <strong>Trust Name:</strong>{" "}
                {trustDetail?.business_name ? trustDetail?.business_name : "-"}
              </p>
              <p>
                <strong>First Name:</strong>{" "}
                {trustDetail?.first_name ? trustDetail?.first_name : "-"}
              </p>
              <p>
                <strong>Last Name:</strong> {trustDetail?.last_name}
              </p>
              <p>
                <strong>Email Address:</strong> {trustDetail?.email}
              </p>
              <p>
                <strong>Mobile Number:</strong>{" "}
                {trustDetail?.mobile ? formatMobile(trustDetail?.mobile) : "-"}
              </p>
              <p className="flex gap-1">
                <strong className="whitespace-nowrap">Address:</strong>{" "}
                {formatedAddress(
                  trustDetail?.street,
                  trustDetail?.suburb?.name,
                  trustDetail?.state?.name,
                  trustDetail?.postal_code,
                )}
              </p>
            </div>
          </div>
          {trustDetail?.account_name && (
            <div className="modal-content mt-4">
              <CardTitle className="text-md mb-2">
                Bank Account Details
              </CardTitle>
              <div className="modal-content-details grid grid-cols-1 md:grid-cols-2 gap-3">
                <p>
                  <strong>Bank Name:</strong>{" "}
                  {trustDetail?.bank
                    ? trustDetail?.bank?.abbreviation +
                      "-" +
                      trustDetail?.bank?.name
                    : "-"}
                </p>
                <p>
                  <strong>Bank Account Name:</strong>{" "}
                  {trustDetail?.account_name ? trustDetail?.account_name : "-"}
                </p>
                <p>
                  <strong>BSB:</strong>{" "}
                  {trustDetail?.bsb ? formatBSBNumber(trustDetail?.bsb) : "-"}
                </p>
                <p>
                  <strong>Account Number:</strong>{" "}
                  {trustDetail?.account_number
                    ? formatAccountNumber(trustDetail?.account_number)
                    : "-"}
                </p>
                <p>
                  <strong>APCA ID:</strong>{" "}
                  {trustDetail?.apca_id?.toString()
                    ? trustDetail?.apca_id
                    : "-"}
                </p>
                <p>
                  <strong>Transactoion Start Date :</strong>{" "}
                  {trustDetail?.transaction_date
                    ? trustDetail?.transaction_date
                    : "-"}
                </p>
                <p>
                  <strong>Opening Balance:</strong>{" "}
                  {trustDetail?.opening_balance
                    ? "$" + formatNumber(Number(trustDetail?.opening_balance))
                    : "$0.00"}
                </p>
              </div>
            </div>
          )}

          {trustDetail?.premiums?.length > 0 && (
            <div className="modal-content mt-4">
              <CardTitle className="text-md mb-2">Premiums</CardTitle>
              <div className="flex flex-wrap gap-2">
                {trustDetail?.premiums?.map((item, index) => (
                  <div className=" rounded-md bg-webSecondary text-white p-2">
                    <div className="modal-content-details grid grid-cols-1 gap-3">
                      <p>
                        <strong>Code:</strong> {item?.code ? item?.code : "-"}
                      </p>
                      <p>
                        <strong>Buyer's Premium Type:</strong>{" "}
                        {item?.premium_type
                          ? premiumTypeList?.find(
                              (pItem) => pItem.value == item?.premium_type,
                            )?.label
                          : "-"}
                      </p>
                      <p>
                        <strong>Amount:</strong>{" "}
                        {item?.amount ? item?.amount : "-"}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {trustDetail?.commissions?.length > 0 && (
            <div className="modal-content mt-4">
              <CardTitle className="text-md mb-2">Commissions</CardTitle>
              <div className="flex flex-wrap gap-2">
                {trustDetail?.commissions?.map((item, index) => (
                  <div className=" rounded-md bg-webSecondary text-white p-2">
                    <div className="modal-content-details grid grid-cols-1 gap-3">
                      <p>
                        <strong>Code:</strong> {item?.code ? item?.code : "-"}
                      </p>
                      <p>
                        <strong>Commission Type:</strong>{" "}
                        {item?.commission_type
                          ? premiumTypeList?.find(
                              (pItem) => pItem.value == item?.commission_type,
                            )?.label
                          : "-"}
                      </p>
                      <p>
                        <strong>Amount:</strong>{" "}
                        {item?.amount ? item?.amount : "-"}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </ResponsiveDrawerForm>
  );
};

export default TrustDetailsPopup;
